import {
  Box,
  Container,
  Typography,
  Grid,
  Button
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ProductCard from './ProductCard';
import "./PopularProduct.css";
import product1 from '../assests/product1.png';
import product2 from '../assests/product2.png';
import product3 from '../assests/product3.png';
import { useProductStore } from "../store/useProductStore";
import { useEffect } from "react";

const FeatureProducts = () => {
  const { recentProduct, getRecentProduct } = useProductStore()
  const navigate = useNavigate()
  //   data 
  const productDetails = [
    {
      image: product1,
      name: "Equipment",
      ratingNumber: 201,
      by: "ZK Pharma",
      price: "$228.85",
      category: 'Dental',
      discountPrice: '$55.8',
    },
    {
      image: product2,
      name: "VIVO  Galaxy phone S9 Ultra",
      ratingNumber: 201,
      by: "ZK Pharma",
      price: "$228.85",
      category: 'Medical',
    },
    {
      image: product3,
      name: "Equipment",
      ratingNumber: 201,
      by: "ZK Pharma",
      price: "$228.85",
      category: 'Dental',
    },
    {
      image: product2,
      name: "VIVO  Galaxy phone S9 Ultra",
      ratingNumber: 201,
      by: "ZK Pharma",
      price: "$228.85",
      category: 'Medical',
      discountPrice: '$55.8',
    },
    {
      image: product1,
      name: "VIVO  Galaxy phone S9 Ultra",
      ratingNumber: 201,
      by: "ZK Pharma",
      price: "$228.85",
      category: 'Medical',
    },
    {
      image: product1,
      name: "VIVO  Galaxy phone S9 Ultra",
      ratingNumber: 201,
      by: "ZK Pharma",
      price: "$228.85",
      category: 'Medical',
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      await getRecentProduct(1, 7, '', '');
    };
    fetchData();
  }, []);

  return (
    <Container maxWidth="xl">
      <Box sx={{ padding: "60px 0 60px" }}>
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              lineHeight: "100%",
              fontWeight: "500",
              fontFamily: `"Quicksand", sans-serif`,
              color: "#008BFF",
              marginBottom: "10px"
            }}
          >
            Products
          </Typography>
          <Typography
            sx={{
              fontSize: "40px",
              lineHeight: "100%",
              fontWeight: "700",
              fontFamily: `"Quicksand", sans-serif`,
              color: "#253D4E",
              marginBottom: "40px"
            }}
          >
            Featured Products
          </Typography>
        </Box>
        <Grid container sx={{ width: "100%" }} spacing={2}>
          {(recentProduct || []).map((productDetail, index) => (
            <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 2 }}
              key={index}
            >
              <ProductCard key={index} productDetail={productDetail}

              />
            </Grid>
          ))}
        </Grid>
        <Box sx={{
          margin: "40px 0",
          textAlign: "center",
        }}>
          <Button sx={{
            width: '312px',
            height: '56px',
            borderRadius: '4px',
            backgroundColor: 'transparent',
            border: "1px solid #008BFF",
            color: '#008BFF',
            fontSize: '16px',
            lineHeight: '21.6px',
            letterSpacing: '0.5px',
            fontWeight: '700',
            fontFamily: `"Quicksand", sans-serif`,
            textTransform: 'capitalize',
            "& a": {
              color: '#008BFF',
              letterSpacing: "0.5",
              transform: 'capitalize',
            },
          }}>
            <Link to="/shop">
              View All Products
            </Link>
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default FeatureProducts;
